import React from 'react';
import PropTypes from 'prop-types';
import config from '../config';

const StaticMap = ({ address, width = 200, height = 200 }) => {
  const { mapsKey } = config.google;

  if (process.env.NODE_ENV !== 'production') {
    return <i className="fas fa-map-marked-alt" style={{ fontSize: '100px' }} />;
  }

  return (
    <a href={`https://maps.google.com/?q=${encodeURIComponent(address)}`} target="_blank" rel="noopener noreferrer">
      <img
        width={width}
        alt="map"
        src={`https://maps.googleapis.com/maps/api/staticmap?center=${encodeURIComponent(
          address
        )}&zoom=11&size=${width}x${height}&maptype=roadmap&markers=anchor:center&key=${mapsKey}&markers=${encodeURIComponent(
          address
        )}`}
      />
    </a>
  );
};

StaticMap.propTypes = {
  address: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
};

export default StaticMap;
